import { gql } from '@apollo/client'

export const SetFavoriteProjectMutation = gql`
    mutation SetFavoriteProjectMutation($input: SetFavoriteProjectInput!) {
        setFavoriteProject(input: $input) {
            id
            isFavorite
        }
    }
`
